import React, { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import { ThemeContext } from 'styled-components';
import FileUpload from '~/components/FileUpload';
import { StyledFileSection } from '../style';

interface Props {
  onPreviewFile: () => void;
}

const TermsAndConditions: React.FC<Props> = ({ onPreviewFile }) => {
  const { t } = useTranslation();
  const { firstColor } = useContext(ThemeContext);
  const { control, setValue } = useFormContext();

  const watchOriginalFilename = useWatch({ control, name: 'originalFilename' });

  function handleFileChange(value: any, name?: string) {
    setValue('file', value);
    setValue('originalFilename', name);
  }

  return (
    <StyledFileSection $primaryColor={firstColor}>
      <div className='file-icon'>
        <Icon name='file pdf outline' size='large' />
      </div>
      <div className='file-info'>
        <div className='file-label'>{t('PDF Document')}</div>
        {watchOriginalFilename ? (
          <div className='file-name' onClick={onPreviewFile}>
            {watchOriginalFilename}
          </div>
        ) : (
          <div className='file-placeholder'>{t('No file selected')}</div>
        )}
      </div>
      <div className='file-actions'>
        <FileUpload
          type='button'
          encodeFiles
          accept={{
            'application/pdf': ['.pdf']
          }}
          mimeTypes={['pdf']}
          sizeLimitInMB={10}
          onChange={handleFileChange}
        />
      </div>
    </StyledFileSection>
  );
};

export default TermsAndConditions;
